"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LinkedinSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function LinkedinSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "LinkedIn"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "linkedin-square"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.429,7.5H18.571A11.084,11.084,0,0,0,7.5,18.571V81.429A11.084,11.084,0,0,0,18.571,92.5H81.429A11.084,11.084,0,0,0,92.5,81.429V18.571A11.084,11.084,0,0,0,81.429,7.5ZM87.5,81.429A6.079,6.079,0,0,1,81.429,87.5H18.571A6.079,6.079,0,0,1,12.5,81.429V18.571A6.079,6.079,0,0,1,18.571,12.5H81.429A6.079,6.079,0,0,1,87.5,18.571Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "29.426",
    y: "42.868",
    width: "8.822",
    height: "28.404"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M60.707,42.156a9.269,9.269,0,0,0-8.347,4.587h-.124V42.868H43.775v28.4h8.813V57.208c0-3.7.7-7.284,5.289-7.284,4.52,0,4.587,4.226,4.587,7.521V71.272h8.813v-15.6C71.277,48.034,69.634,42.156,60.707,42.156Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.832,28.728a5.133,5.133,0,1,0,5.109,5.109A5.111,5.111,0,0,0,33.832,28.728Z"
  })))));
}